"use strict";
const forkConfig = {
  signUpOptionEnabled: false,
  uniSpecificFeaturesEnabled: false,
  exploreEnabled: false,
  multichainFlagEnabled: false,
  analyticsEnabled: false,
  blockedPaths: ["/buy"],
  approvedTokens: false,
  landingPageExternalData: false,
  multipleRouteOptionsEnabled: true,
  apiRoutingEnabled: true,
  routingDisabled: true,
  documentationAvailable: false,
  currencyAvailable: false,
  languageAvailable: false,
  scrollToRefEnabled: false
};
export default forkConfig;
